var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('remotescript',{attrs:{"src":"https://g.alicdn.com/dingding/dingtalk-jsapi/2.6.41/dingtalk.open.js"},on:{"load":_vm.load}})}
var staticRenderFns = []

export { render, staticRenderFns }